const customTabsStyle = theme => ({
  cardTitle: {
    float: "left",
    padding: "10px 10px 10px 0px",
    lineHeight: "24px"
  },
  cardTitleRTL: { 
    float: "right",
    padding: "10px 0px 10px 10px !important"
  },
  displayNone: {
    display: "none !important"
  },
  tabsRoot: {
    minHeight: "unset !important",
    "& $tabRootButton": {
      fontSize: "0.875rem"
    }
  },
  tabsHeader: {
    backgroundColor: "transparent",
    boxShadow: "0 1px 3px 1px rgba(0, 0, 0, 0) !important",
    margin: "-105px 0px 0px -5px !important"
  },
  tabsBody: {
    margin: "0px 0px 0px -30px !important"
  },
  tabRootButton: {
    backgroundColor: "rgba(102,114,229, 0.85)",
    minHeight: "unset !important",
    minWidth: "unset !important",
    width: "unset !important",
    height: "unset !important",
    maxWidth: "unset !important",
    maxHeight: "unset !important",
    padding: "10px 15px",
    borderRadius: "50px",
    lineHeight: "24px",
    border: "0 !important",
    color: "# !important",
    marginLeft: "4px",
    "&:last-child": {
      marginLeft: "0px"
    }
  },
  tabLabelContainer: {
    padding: "0px"
  },
  tabLabel: {
    fontSize: "12px",
    [theme.breakpoints.down("xs")]: {
    fontWeight: "500",
    fontSize: "10px"
  }
},
  tabSelected: {
    backgroundColor: "rgba(102,114,229, 1)",
    transition: "0.2s background-color 0.1s"
  },
  tabWrapper: {
    display: "inline-block",
    minHeight: "unset !important",
    minWidth: "unset !important",
    width: "unset !important",
    height: "unset !important",
    maxWidth: "unset !important",
    maxHeight: "unset !important",
    "& > svg,& > .fab,& > .fas,& > .far,& > .fal,& > .material-icons": {
      verticalAlign: "middle",
      margin: "-1px 5px 0 0"
    }
  }
});

export default customTabsStyle;
